import { GroupInput, IInputProps, Input } from '@/components';
import { memo, useCallback } from 'react';

import { FormikProps } from 'formik';

import Checkbox, { ICheckbox } from '../checkbox';
import { EEditableFilterType, TInputCheckboxValue } from './type';

export const filterInputCheckboxDefaultValue: TInputCheckboxValue = {
	type: EEditableFilterType.INPUT_CHECKBOX,
	searchValue: '',
	searchYes: null,
	searchNo: null,
};

export interface IInputCheckbox {
	formik: FormikProps<{ [key: string]: any }>;
	label: string;
	name: string;
	labelClassName?: string;
	containerClassName?: string;
	inputProps?: Partial<IInputProps>;
	checkboxProps?: {
		yes?: Partial<ICheckbox>;
		no?: Partial<ICheckbox>;
	};
	defaultValue?: TInputCheckboxValue;
}

const InputCheckbox = ({
	formik,
	label,
	name,
	labelClassName,
	containerClassName,
	checkboxProps,
	inputProps,
	defaultValue = filterInputCheckboxDefaultValue,
}: IInputCheckbox) => {
	const _onChangeCheckboxYes = useCallback(
		(e: any) => {
			formik.setValues((prev) => ({
				...prev,
				[name]: {
					...prev[name],
					searchYes: e?.target?.checked || null,
					searchNo: null,
				},
			}));
		},
		[formik]
	);

	const _onChangeCheckboxNo = useCallback(
		(e: any) => {
			formik.setValues((prev) => ({
				...prev,
				[name]: {
					...prev[name],
					searchValue: '',
					searchNo: e?.target?.checked || null,
					searchYes: null,
				},
			}));
		},
		[formik]
	);

	const _onChangeInput = useCallback(
		(e: any) => {
			formik.setValues((prev) => ({
				...prev,
				[name]: {
					...prev[name],
					searchValue: e.target.value,
					searchNo: null,
				},
			}));
		},
		[formik]
	);

	return (
		<GroupInput
			label={label}
			labelClassName={labelClassName}
			containerClassName={containerClassName}
			groupClassName="flex-none gap-x-1.5"
		>
			<Input
				defaultValue={defaultValue?.searchValue || ''}
				value={formik.values[name]?.searchValue || ''}
				onChange={_onChangeInput}
				disabled={formik.values[name]?.searchNo}
				{...inputProps}
				inputClassName="!w-[200px]"
			/>
			<Checkbox
				checked={formik.values[name]?.searchYes}
				onChange={_onChangeCheckboxYes}
				label="유"
				labelClassName="min-w-min"
				defaultChecked={!!defaultValue?.searchYes}
				{...checkboxProps?.yes}
			/>
			<Checkbox
				checked={formik.values[name]?.searchNo}
				onChange={_onChangeCheckboxNo}
				label="무"
				labelClassName="min-w-min"
				containerClassName="ml-1"
				defaultChecked={!!defaultValue?.searchNo}
				{...checkboxProps?.no}
			/>
		</GroupInput>
	);
};

export default memo(InputCheckbox);
